// coins.js — Regras do Insigne Coin na loja.
//
// POR QUE ESTE ARQUIVO EXISTE:
// o valor do coin estava escrito à mão em quatro lugares aqui e dois no
// backend. Seis cópias do mesmo número é exatamente como se cria a situação em
// que o cliente vê um desconto na tela e o servidor debita outro. Este arquivo
// é a fonte única do lado da loja; o espelho é `InsigneBackend/config/insigne.php`.
//
// O valor precisa existir dos dois lados (o front mostra a prévia, o back
// decide de verdade). O que não pode existir é uma TERCEIRA cópia: nada de
// `0.10` solto em JSX.
//
// Em 19/08/2026 o coin passou de R$ 0,25 para R$ 0,10. Os saldos já acumulados
// NÃO foram convertidos — decisão do dono: quem tinha 100 coins continua com
// 100 coins, que passaram a valer R$ 10,00 em vez de R$ 25,00.

/** Valor de 1 coin em CENTAVOS. Inteiro para o cálculo não acumular erro de float. */
export const COIN_VALOR_CENTAVOS = 10;

/** Valor de 1 coin em reais (R$ 0,10). */
export const COIN_VALOR = COIN_VALOR_CENTAVOS / 100;

/** Coins ganhos ao publicar uma avaliação. Editar depois NÃO paga de novo. */
export const COINS_POR_AVALIACAO = 10;

/** Coins ganhos por real gasto (o frete não conta). */
export const COINS_POR_REAL = 1;

/** "R$ 0,10" — para textos explicativos, sempre a partir da constante. */
export const COIN_VALOR_TEXTO = COIN_VALOR.toFixed(2).replace(".", ",");

/**
 * Converte uma quantidade de coins no valor em reais que ela representa.
 * O cálculo passa por centavos e volta, para 3 coins darem 0,30 e não
 * 0.30000000000000004.
 */
export const coinsEmReais = (coins) =>
  (Math.max(0, Math.floor(Number(coins) || 0)) * COIN_VALOR_CENTAVOS) / 100;

/** "R$ 12,40" a partir de um número de coins. */
export const coinsEmReaisTexto = (coins) =>
  coinsEmReais(coins).toFixed(2).replace(".", ",");
